import { Link, useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList, settingsRouteList } from "../App";
import { lang } from "../assets/languages/en.language";
import { usePwaViewportWidth } from "../hooks/useScreenWidth";
import mixpanel from "../services/mixpanel";
import { getVpFontSize, resetLocalEnv } from "../services/utils";
import api from "../services/api";
import { storageKey } from "../configs/config";
import { RoundCta } from "../styles/Button.style";
import { MainContainer, RootContainer } from "../styles/Container.style";
import { BigTitle } from "../styles/Text";
import { Column, Gap } from "../styles/Utils";

export default function SettingsPage() {
  const theme = useTheme();
  const viewportWidth = usePwaViewportWidth();

  const navigate = useNavigate();

  const pageLinks = [
    {
      title: lang.settingsPage.PageLinkNames.distance,
      route: settingsRouteList.distance,
    },
    {
      title: lang.settingsPage.PageLinkNames.notifications,
      route: settingsRouteList.notifications,
    },
    {
      title: lang.settingsPage.PageLinkNames.termOfUse,
      route: settingsRouteList.termOfUse,
      // route: routeList.warningMatch,
    },
  ];

  const openProfilePage = (route: string) => {
    console.log("openProfilePage");
    navigate(route);
  };

  const logout = async () => {
    const deviceToken = localStorage.getItem(storageKey.deviceToken);
    if (deviceToken) {
      try {
        await api.removeDeviceToken({ deviceToken });
      } catch (error) {
        console.error("Failed to remove device token on logout", error);
      }
    }
    resetLocalEnv();
    navigate(routeList.landing);
  };

  return (
    <RootContainer>
      <BigTitle $fontSize={getVpFontSize(viewportWidth, 15)}>{lang.settingsPage.title}</BigTitle>
      <MainContainer $justifyContent="space-between" $flexGrow={1}>
        <Column $gap={1}>
          {pageLinks.map((e) => (
            <RoundCta
              key={e.title}
              onClick={() => openProfilePage(e.route)}
              $color={theme.color.tertiaryLight}
              $background={theme.color.primaryDark}
              $textAlign="left"
            >
              {e.title}
            </RoundCta>
          ))}
          <RoundCta
            onClick={logout}
            $color={theme.color.tertiaryLight}
            $background={theme.color.primaryDark}
            $textAlign="left"
          >
            {lang.settingsPage.buttonLabel.logout}
          </RoundCta>
          <Link
            to={import.meta.env.VITE_BUG_REPORT_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => mixpanel.track("Report Bug")}
          >
            <RoundCta $color={theme.color.tertiaryLight} $background={theme.color.primaryDark} $textAlign="left">
              {lang.settingsPage.buttonLabel.bugReport}
            </RoundCta>
          </Link>
          <Link
            to={import.meta.env.VITE_CONTACT_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => mixpanel.track("Report Bug")}
          >
            <RoundCta $color={theme.color.tertiaryLight} $background={theme.color.primaryDark} $textAlign="left">
              {lang.settingsPage.buttonLabel.contact}
            </RoundCta>
          </Link>
        </Column>
        <Gap $height={4} />
        <Image src="/illustrations/man-sofa-dog.png" />
      </MainContainer>
    </RootContainer>
  );
}
const Image = styled.img`
  width: 80%;
  transform: translateY(3rem);
`;
